﻿window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('../../../share/client/js/scrolltop');
require('../../../share/client/js/top');
require('../../../share/client/js/login');
require('../../../share/client/js/footer');

$(window).scroll(function () {
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var overheight = 90;

    if (scrollTop < overheight) {
        var top = overheight - scrollTop;
        $('.left').css('top', top + 'px');
    } else {
        $('.left').css('top', '10px');
    }
});

// 获取服务器时间
window.getServerTime = function () {
    var ltime = 0;
    $.ajax({
        type: 'get',
        async: false,
        url: '/home/systime',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            ltime = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return ltime;
};

window.getPictures = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: '/config/picture' + '?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getPicturesets = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: '/config/pictureset' + '?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getLives = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: '/config/live' + '?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getVideos = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: '/config/video?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getAudios = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: '/config/audio?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

// 获取栏目ID
window.getColumnID = function (key) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: '/config/column_id?key=' + key,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

// 获取列表广告
window.getListAds = function (column, start, stop) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: '/config/ads-list?column=' + column + '&start=' + start + '&stop=' + stop,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

// 获取位置广告
window.getPositionAds = function (key) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: '/config/position-ads?key=' + key,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.onClickAds = function (id, adID, adType) {
    var data = {
        'id': id,
        'ad_id': adID,
        'ad_type': adType
    };
    $.ajax({
        type: 'post',
        async: true,
        url: '/config/ads-click',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data && data.message) {
                console.log(data);
            }
        },
        error: function (error) {
            console.log(error);
        }
    });
};

// 等待GIF
window.showwait = function () {
    if ($('#wait').css('display') != 'block')
        $('#wait').show();
};

window.hidewait = function () {
    if ($('#wait').css('display') == 'block')
        $('#wait').hide();
};

window.long2time = function (seconds) {
    if (isNaN(parseInt(seconds)))
        return '00:00';
    seconds = parseInt(seconds);
    var m = parseInt(seconds / 60);
    var s = seconds % 60;
    if (m < 10)
        m = '0' + m;
    if (s < 10)
        s = '0' + s;
    return m + ':' + s;
};

window.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
};
